module.exports = __webpack_public_path__ + "95b89da1.png";